import React, { useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { orderAction, shopAction } from "@redux/modules";
import {
  FaCheck,
  FaShoppingBag,
  FaBoxOpen,
  FaArrowRight,
  FaCommentDots,
} from 'react-icons/fa';

// Header - Footer
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';

// Components
import GlobalLoader from "@components/GlobalLoader";

const OrderSummary = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [orderSuccess, setOrderSuccess] = useState(false);

  const isLoading = useSelector((state) => state.order?.isLoading);
  const paymentToken = localStorage.getItem("paymentToken");
  const isOrderForCatalog = localStorage.getItem("isOrderForCatalog");
  const payWithScore = localStorage.getItem("PayWithScore");
  // Hediye çeki siparişi mi: Cart sayfası createOrder yanıtındaki giftCardOrder bayrağını burada okur.
  const isGiftCardOrder = localStorage.getItem("giftCardOrder") === "true";

  // Tamamlanma ekranı gösterildikten sonra bayrağı temizle (geri/yeniden ziyarette kalmasın).
  useEffect(() => {
    return () => {
      localStorage.removeItem("giftCardOrder");
    };
  }, []);
  const checkOrderResult = useSelector(
    (state) => state.order?.checkOrderResult
  );

  useEffect(() => {
    dispatch(orderAction.checkOrderResult());
  }, [dispatch]);

  useEffect(() => {
    if (orderSuccess) {
      dispatch(shopAction.getCart());
      dispatch(shopAction.getBrandCartList());
    }
  }, [orderSuccess]);

  useEffect(() => {
    if (paymentToken && isOrderForCatalog && checkOrderResult?.data) {
      dispatch(
        orderAction.paymentFinishSession(paymentToken, isOrderForCatalog)
      )
        .then((res) => {
          if (res.isHttpSuccess) {
            localStorage.removeItem("paymentToken");
            localStorage.removeItem("isOrderForCatalog");
            if (res.data === "1") {
              setOrderSuccess(true);
            } else if (res.data === "0") {
              setOrderSuccess(false);
            }
          } else {
            setOrderSuccess(false);
          }
        })
        .catch(() => {
          setOrderSuccess(false);
        });
    } else {
      setTimeout(() => {
        localStorage.removeItem("PayWithScore");
      }, 5000);
    }
  }, [dispatch, checkOrderResult, paymentToken, isOrderForCatalog]); // Dependency array'e eksik dependencies eklendi

  return (
    <>
      <Header />

      <main className="pb-5">
        {isLoading ? (
          <GlobalLoader />
        ) : isLoading === false ? (
          <div className="container">
            <div className="row justify-content-center py-5">
              <div className="col-lg-8">
                {checkOrderResult?.data || payWithScore === "true" ? (
                  isGiftCardOrder ? (
                    /* Hediye çeki siparişi tamamlanma ekranı */
                    <div className="text-center mb-5">
                      <div className="mb-4">
                        <div
                          style={{
                            width: "120px",
                            height: "120px",
                            borderRadius: "50%",
                            backgroundColor: "#5cb85c",
                            margin: "0 auto",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            animation: "scale-up 0.5s ease-in-out",
                          }}
                        >
                          <FaCheck size={60} color="white" />
                        </div>
                      </div>
                      <h1 className="display-4 fw-bold text-dark mb-3">
                        Sipariş Tamamlandı!
                      </h1>
                      <p className="lead text-muted mb-4">
                        Siparişiniz oluşturuldu ve SMS ile cep telefonunuza
                        gönderildi.
                      </p>
                      <div className="d-inline-flex align-items-center gap-2">
                        <span
                          className="d-inline-flex align-items-center justify-content-center"
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            backgroundColor: "#e7f0ff",
                          }}
                        >
                          <FaCommentDots className="text-primary" />
                        </span>
                        <span className="fw-bold text-primary fs-5">
                          Hediye çekiniz SMS ile iletildi
                        </span>
                      </div>
                    </div>
                  ) : (
                  <>
                    {/* Başarı Animasyonu Alanı */}
                    <div className="text-center mb-5">
                      <div className="success-animation mb-4">
                        <div className="checkmark-circle">
                          <div
                            className="success-icon"
                            style={{
                              width: "120px",
                              height: "120px",
                              borderRadius: "50%",
                              backgroundColor: "#5cb85c",
                              margin: "0 auto",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              animation: "scale-up 0.5s ease-in-out",
                            }}
                          >
                            <FaCheck size={60} color="white" />
                          </div>
                        </div>
                      </div>
                      <h1 className="display-4 fw-bold text-success mb-3">
                        Sipariş Tamamlandı!
                      </h1>
                      <p className="lead mb-1">
                        {/* Teşekkürler, {orderDetails.customer.name}! */}
                      </p>
                      <p className="mb-4">
                        Siparişiniz başarıyla oluşturuldu ve çok yakında
                        hazırlanmaya başlanacak.
                      </p>
                      <div className="order-number mb-5">
                        {/* <p className="text-muted mb-1">Sipariş Numaranız</p> */}
                        {/* <h3 className="fw-bold">{orderDetails.orderId}</h3> */}
                      </div>
                    </div>
                    {/* Sonraki Adımlar */}
                    <div className="my-5 text-center">
                      <h5 className="mb-4">Sonraki Adımlar</h5>
                      <div className="row g-3">
                        <div className="col-sm-6">
                          <Link
                            to="/profile/orders"
                            className="btn btn-primary w-100 py-3 rounded-pill"
                          >
                            Siparişlerim
                          </Link>
                        </div>
                        <div className="col-sm-6">
                          <Link
                            to="/shop"
                            className="btn btn-outline-primary w-100 py-3 rounded-pill"
                          >
                            Alışverişe Devam Et{" "}
                            <FaArrowRight className="ms-2" />
                          </Link>
                        </div>
                      </div>
                    </div>

                    {/* Bilgilendirme Alanı */}
                    <div className="card border-0 shadow-sm mb-5">
                      <div className="card-body p-4">
                        <div className="row g-4">
                          <div className="col-md-4">
                            <div
                              className="text-center p-3 h-100"
                              style={{
                                background: "#f8f9fa",
                                borderRadius: "10px",
                              }}
                            >
                              <FaShoppingBag
                                size={38}
                                className="text-primary mb-3"
                              />
                              <h5>Sipariş Onaylandı</h5>
                              {/* <p className="small text-muted mb-0">
                            {orderDetails.orderDate} tarihinde siparişiniz
                            başarıyla oluşturuldu.
                          </p> */}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div
                              className="text-center p-3 h-100"
                              style={{
                                background: "#f8f9fa",
                                borderRadius: "10px",
                              }}
                            >
                              <FaBoxOpen
                                size={38}
                                className="text-primary mb-3"
                              />
                              <h5>Hazırlanıyor</h5>
                              <p className="small text-muted mb-0">
                                Siparişiniz şu anda hazırlanıyor ve kargoya
                                verilecek.
                              </p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div
                              className="text-center p-3 h-100"
                              style={{
                                background: "#f8f9fa",
                                borderRadius: "10px",
                              }}
                            >
                              <i className="fas fa-truck fs-1 text-primary mb-3"></i>
                              <h5>Teslimat Bilgisi</h5>
                              <p className="small text-muted mb-0">
                                Tahmini teslimat süresi: 3-5 iş günü
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                  )
                ) : (
                  <>
                    {/* Başarısız Sipariş Alanı */}
                    <div className="text-center mb-5">
                      <div className="error-animation mb-4">
                        <div
                          className="error-icon"
                          style={{
                            width: "120px",
                            height: "120px",
                            borderRadius: "50%",
                            backgroundColor: "#dc3545",
                            margin: "0 auto",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            animation: "scale-up 0.5s ease-in-out",
                          }}
                        >
                          <span style={{ fontSize: "60px", color: "white" }}>
                            ✕
                          </span>
                        </div>
                      </div>
                      <h1 className="display-4 fw-bold text-danger mb-3">
                        Sipariş Başarısız!
                      </h1>
                      <p className="mb-4">
                        Siparişiniz oluşturulurken bir hata oluştu. Lütfen daha
                        sonra tekrar deneyiniz.
                      </p>
                    </div>
                  </>
                )}
                {/* Teşekkür Mesajı */}
                <div
                  className="alert alert-light text-center p-4 border"
                  role="alert"
                >
                  <p className="mb-0">
                    <strong>Bilgi:</strong>{" "}
                    {isGiftCardOrder
                      ? "Siparişiniz ile ilgili sorularınız için müşteri hizmetlerimizle iletişime geçebilirsiniz."
                      : "Siparişiniz ve teslimat durumu hakkında güncellemeler e-posta adresinize gönderilecektir. Siparişiniz ile ilgili sorularınız için müşteri hizmetlerimizle iletişime geçebilirsiniz."}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          // Sadece yönlendirme için geçici yükleme göstergesi
          <div className="container text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Yükleniyor...</span>
            </div>
            <p className="mt-3">Brand Cart sayfasına yönlendiriliyorsunuz...</p>
          </div>
        )}
      </main>

      <Footer />

      <style>
        {`
          @keyframes scale-up {
            0% { transform: scale(0); opacity: 0; }
            100% { transform: scale(1); opacity: 1; }
          }
        `}
      </style>
    </>
  );
};

export default OrderSummary;
